import AddIcon from '@mui/icons-material/Add';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import { Box, Button, Typography, Grid, useTheme, useMediaQuery, CircularProgress, LinearProgress, Avatar, Menu, MenuItem, IconButton } from '@mui/material';
import { useSnackbar } from 'notistack';
import { useState, useEffect } from 'react';
import { useLocation, useHistory } from 'react-router-dom';
import { AppButton } from '../../../../Components/AppButton';
import KenLoader from '../../../../GlobalComponents/KenLoader';
import { getGoalTask, markGoalComplete } from '../../../../Utils/apiService';
import { formatDate2 } from '../../../../Utils/helperFunctions';
import { useStyles } from '../../styles';
import routes from '../../../../Utils/routes';

const statusColors: { [key: string]: string } = {
  'Not Started': '#5E35B1',
  'In Progress': '#F57C00',
  'Completed': '#4CAF50',
  'Closed': '#9E9E9E',
  'Upcoming - Requested': '#F57C00',
  'Upcoming - Confirmed': '#5E35B1',
  'On track': '#4CAF50',
  'At risk': '#F44336',
};

const GoalsAndMilestonesData: React.FC = () => {
  const { state }:any = useLocation();
  const { data, mentorName, milestoneData } = state || { data: {}, mentorName: '', milestoneData: null };
  const navigate = useHistory();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const { enqueueSnackbar } = useSnackbar();

  console.log('=== MileStoneData Component Mount ===');
  console.log('Raw state from useLocation:', state);
  console.log('Parsed data:', data);
  console.log('Parsed mentorName:', mentorName);
  console.log('Parsed milestoneData:', milestoneData);
  console.log('Full state object:', JSON.stringify(state));
  console.log('Current location:', window.location.href);
  console.log('Expected route:', routes.goalsAndMilestonesData);
  
  // Check if this is a goal navigation
  if (data?.goalName && !data?.mileStoneGoals) {
    console.log('🎯 GOAL NAVIGATION DETECTED');
    console.log('Goal data:', data);
    console.log('Parent milestone data:', milestoneData);
    if (milestoneData) {
      console.log('✅ Parent milestone data is available');
    } else {
      console.log('⚠️ WARNING: No parent milestone data provided');
    }
  } else if (data?.mileStoneName) {
    console.log('📋 MILESTONE NAVIGATION DETECTED');
    console.log('Milestone data:', data);
  }

  const classes = useStyles();
  const [loading, setLoading] = useState<boolean>(false);
  const [goalTask, setGoalTask] = useState<any>([]);
  
  // Determine if we're viewing milestone or goal data
  const isGoalData = data?.goalName && !data?.mileStoneGoals;
  const milestoneDataToUse = isGoalData ? milestoneData : data;
  const [activeGoal, setActiveGoal] = useState(
    isGoalData ? data : (data?.mileStoneGoals?.[0] || {})
  );
  
  console.log('=== MileStoneData Data Check ===');
  console.log('data:', data);
  console.log('milestoneData:', milestoneData);
  console.log('isGoalData:', isGoalData);
  console.log('milestoneDataToUse:', milestoneDataToUse);
  console.log('activeGoal:', activeGoal);
  const [goalOptionsAnchorEl, setGoalOptionsAnchorEl] = useState<null | HTMLElement>(null);

  // Update activeGoal when data changes
  useEffect(() => {
    if (isGoalData && data) {
      console.log('Setting activeGoal to goal data:', data);
      setActiveGoal(data);
    } else if (data?.mileStoneGoals?.[0]) {
      console.log('Setting activeGoal to first milestone goal:', data.mileStoneGoals[0]);
      setActiveGoal(data.mileStoneGoals[0]);
    }
  }, [data, isGoalData]);

  // Calculate overall milestone progress based on goals
  const calculateMilestoneProgress = () => {
    const goalsToUse = isGoalData ? [data] : (milestoneDataToUse?.mileStoneGoals || []);
    if (!goalsToUse || goalsToUse.length === 0) return 0;
    
    const totalProgress = goalsToUse.reduce((sum: number, goal: any) => {
      return sum + (goal.goalProgressCurrentValue || 0);
    }, 0);
    
    return Math.round(totalProgress / goalsToUse.length);
  };

  const milestoneProgress = calculateMilestoneProgress();

  useEffect(() => {
    const goalId = isGoalData ? data?.id : (milestoneDataToUse?.mileStoneGoals?.[0]?.id);
    if (goalId) {
      setLoading(true);
      getGoalTask(goalId)
        .then((res: any) => {
          setGoalTask(res?.result);
        })
        .finally(() => {
          setLoading(false);
        });
    }
  }, [data, isGoalData, milestoneDataToUse]);

  // Check if we have valid data after all hooks
  if (!state || !data) {
    console.error('❌ MileStoneData: No state or data received!');
    console.log('Current URL:', window.location.href);
    console.log('Expected route:', '/Goals-&-Milestones/Details');
    return (
      <Box sx={{ p: 4, textAlign: 'center' }}>
        <Typography>No data available. Please navigate from the Goals & Milestones page.</Typography>
      </Box>
    );
  }

  const handleGoalClick = async (goal: any, index: number) => {
    setActiveGoal(goal);
    await getGoalTask(goal?.id).then((res: any) => {
      console.log(res?.result, 'res from goal task');
      setGoalTask(res?.result);
    });
  };

  const handleGoalOptionsClick = (event: React.MouseEvent<HTMLElement>) => {
    setGoalOptionsAnchorEl(event.currentTarget);
  };

  const handleGoalOptionsClose = () => {
    setGoalOptionsAnchorEl(null);
  };

  const handleEditGoal = () => {
    handleGoalOptionsClose();
    console.log('=== MileStoneData handleEditGoal ===');
    console.log('activeGoal:', activeGoal);
    console.log('milestoneDataToUse:', milestoneDataToUse);
    console.log('isGoalData:', isGoalData);
    console.log('data:', data);
    console.log('milestoneData:', milestoneData);
    
    // Ensure we have the correct data
    const goalData = activeGoal && Object.keys(activeGoal).length > 0 ? activeGoal : data;
    const parentMilestoneData = milestoneDataToUse && Object.keys(milestoneDataToUse).length > 0 ? milestoneDataToUse : milestoneData;
    
    console.log('Final goalData:', goalData);
    console.log('Final parentMilestoneData:', parentMilestoneData);
    
    // Navigate to addgoalmilestones route with goal data for editing
    navigate.push(routes.addgoalmilestones, { 
      data: goalData, 
      dataFor: 'editGoal',
      milestoneData: parentMilestoneData // Pass the correct milestone data for context
    });
  };

  const handleMarkGoalComplete = () => {
    handleGoalOptionsClose();
    // Show alert with the required information
    const payload = {
      goalId: activeGoal?.id,
      goalProgressCurrentValue: activeGoal?.goalProgressTarget,
    };
    
    markGoalComplete(payload)
      .then((res: any) => {
        if (res?.status === 'true' && res?.result?.success) {
          enqueueSnackbar('Goal marked as complete successfully!', { variant: 'success' });
          
          // Update the active goal's progress
          setActiveGoal((prev: any) => ({
            ...prev,
            goalProgressCurrentValue: prev.goalProgressTarget,
            status: 'Completed'
          }));
          
          // Navigate back to refresh the parent component data
          // This will trigger a re-render of the parent component
          setTimeout(() => {
            navigate.goBack();
          }, 1000); // Small delay to show the success message
        } else {
          enqueueSnackbar('Failed to mark goal as complete', { variant: 'error' });
        }
      })
      .catch((error: any) => {
        console.error('Error marking goal complete:', error);
        enqueueSnackbar('Something went wrong', { variant: 'error' });
      });
  };

  return (
    <>
      {loading ? (
        <KenLoader />
      ) : (
        <>
          {isMobile ? (
            // Mobile View
            <Box sx={{ 
              minHeight: '100vh',
              padding: '0px'
            }}>
              {/* Foundation Progress Section */}
              <Box sx={{ 
                background: '#FFFFFF',
                padding: '20px 16px',
                borderBottom: '1px solid #E0E0E0'
              }}>
                <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '12px' }}>
                  <Box>
                    <Typography sx={{ 
                      fontSize: '16px', 
                      fontWeight: 600, 
                      color: '#333333'
                    }}>
                      {milestoneDataToUse?.mileStoneName || data?.goalName || 'Foundation'}
                    </Typography>
                    {milestoneDataToUse?.mileStoneDuration && (
                      <Typography sx={{ 
                        fontSize: '12px', 
                        color: '#666666',
                        marginTop: '4px'
                      }}>
                        Duration: {milestoneDataToUse.mileStoneDuration}
                      </Typography>
                    )}
                  </Box>
                  <Box sx={{ 
                    position: 'relative', 
                    display: 'inline-flex',
                    alignItems: 'center',
                    justifyContent: 'center'
                  }}>
                    <CircularProgress
                      variant="determinate"
                      value={milestoneProgress}
                      size={50}
                      thickness={4}
                      sx={{
                        color: milestoneProgress >= 80 ? '#4CAF50' : milestoneProgress >= 50 ? '#F57C00' : '#F44336',
                        '& .MuiCircularProgress-circle': {
                          strokeLinecap: 'round',
                        },
                      }}
                    />
                    <Box sx={{
                      position: 'absolute',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                    }}>
                      <Typography sx={{ 
                        fontSize: '12px', 
                        fontWeight: 600, 
                        color: milestoneProgress >= 80 ? '#4CAF50' : milestoneProgress >= 50 ? '#F57C00' : '#F44336'
                      }}>
                        {milestoneProgress}%
                      </Typography>
                    </Box>
                  </Box>
                </Box>
                
                {(data?.mileStoneStartDate || data?.mileStoneEndDate) && (
                  <Typography sx={{ 
                    fontSize: '12px', 
                    color: '#666666',
                    marginBottom: '8px',
                    lineHeight: 1.4
                  }}>
                    Duration: {data?.mileStoneStartDate ? formatDate2(data.mileStoneStartDate) : 'N/A'} → {data?.mileStoneEndDate ? formatDate2(data.mileStoneEndDate) : 'N/A'}
                  </Typography>
                )}
                
                {mentorName && (
                  <Box sx={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                    <Typography sx={{ fontSize: '12px', color: '#666666' }}>
                      Linked to:
                    </Typography>
                    <Avatar 
                      sx={{
                        width: '20px',
                        height: '20px',
                        fontSize: '10px',
                        fontWeight: 600,
                        backgroundColor: '#F0EDF6',
                        color: '#604797'
                      }}
                    >
                      {mentorName?.charAt(0)?.toUpperCase()}
                    </Avatar>
                    <Typography sx={{ fontSize: '12px', color: '#666666' }}>
                      {mentorName}
                    </Typography>
                  </Box>
                )}
              </Box>

              {/* Goals Section */}
              <Box sx={{ padding: '16px', paddingBottom: '80px' }}>
                <Typography sx={{ 
                  fontFamily: 'General Sans',
                  fontWeight: 500,
                  fontSize: '14px',
                  lineHeight: '140%',
                  letterSpacing: '0%',
                  color: '#333333',
                  marginBottom: '16px'
                }}>
                  Goals
                </Typography>

                {/* Goal Cards */}
                {(isGoalData ? [data] : (milestoneDataToUse?.mileStoneGoals || [])).map((goal: any, index: number) => (
                  <Box
                    key={goal.id}
                    sx={{
                      background: '#FFFFFF',
                      borderRadius: '8px',
                      padding: '16px',
                      marginBottom: '12px',
                      boxShadow: '0px 1px 3px rgba(0, 0, 0, 0.1)',
                      border: '1px solid #E0E0E0',
                      cursor: 'pointer'
                    }}
                    onClick={() => handleGoalClick(goal, index)}
                  >
                    {/* Goal Header with Status */}
                    <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: '8px' }}>
                      <Box sx={{ flex: 1 }}>
                        <Typography sx={{ 
                          fontSize: '12px', 
                          color: '#666666',
                          fontWeight: 500,
                          marginBottom: '4px'
                        }}>
                          Goal #{index + 1}
                        </Typography>
                        <Typography sx={{ 
                          fontSize: '14px', 
                          fontWeight: 600, 
                          color: '#333333',
                          marginBottom: '4px',
                          lineHeight: 1.3
                        }}>
                          {goal?.goalName}
                        </Typography>
                        <Typography sx={{ 
                          fontSize: '11px', 
                          color: '#666666',
                          marginBottom: '0px'
                        }}>
                          {goal?.goalCreatedDate ? `Updated on ${new Date(goal.goalCreatedDate).toLocaleDateString('en-GB', { day: '2-digit', month: '2-digit', year: 'numeric' }).replace(/\//g, '-')}` : 'No update date'}
                        </Typography>
                      </Box>
                      
                      <Box sx={{ display: 'flex', alignItems: 'flex-start', gap: '8px' }}>
                        {/* <Box
                          sx={{
                            padding: '4px 8px',
                            borderRadius: '4px',
                            fontSize: '10px',
                            fontWeight: 500,
                            color: '#FFFFFF',
                            backgroundColor: statusColors[goal.status] || '#666666',
                          }}
                        >
                          {goal?.status}
                        </Box> */}
                        <IconButton
                          size="small"
                          onClick={(event) => {
                            event.stopPropagation();
                            setActiveGoal(goal);
                            setGoalOptionsAnchorEl(event.currentTarget);
                          }}
                          sx={{ p: 0.5 }}
                        >
                          <MoreVertIcon sx={{ color: '#666666', fontSize: '18px' }} />
                        </IconButton>
                      </Box>
                    </Box>

                    {/* Progress Section */}
                    <Box sx={{ marginBottom: '12px' }}>
                      <Box sx={{ display: 'flex', justifyContent: 'flex-start', marginBottom: '4px' }}>
                        <Typography sx={{ 
                          fontSize: '12px', 
                          fontWeight: 600, 
                          color: goal?.goalProgressCurrentValue === goal?.goalProgressTarget ? '#4CAF50' : '#333333'
                        }}>
                          {goal?.goalProgressCurrentValue === goal?.goalProgressTarget ? 'Completed' : `${goal.goalProgressCurrentValue || 0}%`}
                        </Typography>
                      </Box>
                      <LinearProgress
                        variant="determinate"
                        value={goal.goalProgressCurrentValue || 0}
                        sx={{
                          height: 6,
                          borderRadius: 3,
                          backgroundColor: '#F0F0F0',
                          '& .MuiLinearProgress-bar': {
                            backgroundColor: statusColors[goal.status] || '#4CAF50',
                            borderRadius: 3,
                          },
                        }}
                      />
                    </Box>

                    {/* Duration and Function */}
                    {(goal.goalStartDate || goal.goalEndDate) && (
                      <Typography sx={{ 
                        fontSize: '11px', 
                        color: '#666666',
                        marginBottom: '4px'
                      }}>
                        Duration: {goal.goalStartDate ? formatDate2(goal.goalStartDate) : 'N/A'} → {goal.goalEndDate ? formatDate2(goal.goalEndDate) : 'N/A'}
                      </Typography>
                    )}
                    
                    {goal?.functionType && (
                      <Typography sx={{ 
                        fontSize: '11px', 
                        color: '#666666',
                        marginBottom: '8px'
                      }}>
                        Function: {goal.functionType}
                      </Typography>
                    )}

                    {/* Linked Person */}
                    {(goal?.assignedTo || mentorName) && (
                      <Box sx={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                        <Avatar 
                          sx={{
                            width: '20px',
                            height: '20px',
                            fontSize: '10px',
                            fontWeight: 600,
                            backgroundColor: '#333333',
                            color: '#FFFFFF'
                          }}
                        >
                          {(goal?.assignedTo || mentorName)?.charAt(0)?.toUpperCase()}
                        </Avatar>
                        <Typography sx={{ fontSize: '11px', color: '#666666' }}>
                          {goal?.assignedTo || mentorName}
                        </Typography>
                      </Box>
                    )}
                  </Box>
                ))}

                {/* If no goals */}
                {(!isGoalData && (!milestoneDataToUse?.mileStoneGoals || milestoneDataToUse.mileStoneGoals.length === 0)) && (
                  <Box sx={{
                    background: '#FFFFFF',
                    borderRadius: '8px',
                    padding: '40px 20px',
                    textAlign: 'center',
                    boxShadow: '0px 1px 3px rgba(0, 0, 0, 0.1)'
                  }}>
                    <Typography sx={{ 
                      fontSize: '14px', 
                      color: '#666666' 
                    }}>
                      No milestone goals available
                    </Typography>
                  </Box>
                )}
              </Box>

              {/* Add New Milestone Button - Fixed at bottom */}
              <Box sx={{ 
                position: 'fixed',
                bottom: 70,
                left: 0,
                right: 0,
                padding: '16px',
                backgroundColor: '#FFFFFF',
                borderTop: '1px solid #E0E0E0',
                zIndex: 1000
              }}>
                <Button
                  variant="contained"
                  fullWidth
                  sx={{
                    backgroundColor: '#F0EDF6',
                    color: '#604797',
                    fontSize: '14px',
                    fontWeight: 500,
                    padding: '12px 24px',
                    borderRadius: '8px',
                    textTransform: 'none',
                    boxShadow: 'none',
                    border: 'none',
                    '&:hover': {
                      backgroundColor: '#E8E3F3',
                      boxShadow: 'none'
                    }
                  }}
                  onClick={() => navigate.push(routes.addgoalmilestones)}
                >
                  Add new milestone
                </Button>
              </Box>

              {/* Mobile Goal Options Menu */}
              <Menu
                id="mobile-goal-options-menu"
                anchorEl={goalOptionsAnchorEl}
                open={Boolean(goalOptionsAnchorEl)}
                onClose={handleGoalOptionsClose}
                anchorOrigin={{
                  vertical: 'bottom',
                  horizontal: 'right',
                }}
                transformOrigin={{
                  vertical: 'top',
                  horizontal: 'right',
                }}
              >
                <MenuItem onClick={handleEditGoal}>Edit Goal</MenuItem>
                <MenuItem 
                  onClick={handleMarkGoalComplete}
                  disabled={activeGoal?.goalProgressCurrentValue === activeGoal?.goalProgressTarget}
                >
                  Mark Goal as Complete
                </MenuItem>
              </Menu>
            </Box>
          ) : (
            // Desktop View
            <Box className={classes.BoxContainer}>
              <Box className={classes.BoxSubContainer}>
                <Typography className={classes.milestoneTitle}>Goals & Milestones</Typography>
                <AppButton variant="contained" startIcon={<AddIcon />} className={classes.addMilestoneBtn} onClick={() => navigate.push(routes.addgoalmilestones)}>
                  Add Milestones
                </AppButton>
              </Box>

          <Box className={classes.mainContent}>
            {/* Left Panel */}
            <Grid container spacing={2}>
              <Grid item xs={3.5}>
                <Box className={classes.leftPanel}>
                  <Box className={classes.milestonebar}>
                    <Box className={classes.leftPanelHeader}>
                      <Typography className={classes.milestoneId}>MILESTONE</Typography>
                      {/* <Button className={classes.optionsButton}>
                      Options <ExpandMoreIcon />{' '}
                    </Button> */}
                    </Box>

                    <Box className={classes.milestoneTitleContainer}>
                      <Typography className={classes.MilestoneTitle}>{milestoneDataToUse?.mileStoneName || data?.goalName}</Typography>
                      {milestoneDataToUse?.mileStoneDuration && (
                        <Typography sx={{ 
                          fontSize: '14px', 
                          color: '#666666',
                          marginTop: '4px'
                        }}>
                          Duration: {milestoneDataToUse.mileStoneDuration}
                        </Typography>
                      )}
                      {/* <Typography className={classes.statusText} style={{ color: statusColors[data.status] }}>
                        {data.status}
                      </Typography> */}
                    </Box>
                  </Box>

                  {/* Goal Cards */}
                  <Box sx={{ mt: { xs: '18px', ultraHD: '24px' } }}>
                    {(isGoalData ? [data] : (milestoneDataToUse?.mileStoneGoals || [])).length > 0 ? (
                      (isGoalData ? [data] : (milestoneDataToUse?.mileStoneGoals || [])).map((goal: any, index: number) => (
                        <Box
                          key={goal.id}
                          className={`${classes.goalCard} ${goal.id === activeGoal?.id ? classes.activeGoalCard : classes.inactiveGoalCard}`}
                          onClick={() => handleGoalClick(goal, index)}
                          sx={{ cursor: 'pointer' }}
                        >
                          <Box className={classes.goalCardContainer}>
                            <Typography className={`${classes.goalId} ${goal?.id === activeGoal?.id ? classes.activeGoalId : classes.inactiveGoalId}`}>MILESTONE #{index + 1}</Typography>
                            <Typography className={classes.goalTitle}>{goal?.goalName}</Typography>
                            <Typography 
                              className={classes.goalTitle}
                              sx={{ 
                                float: 'right',
                                color: goal?.goalProgressCurrentValue === goal?.goalProgressTarget ? '#4CAF50' : 'inherit' 
                              }}
                            >
                              {goal?.goalProgressCurrentValue === goal?.goalProgressTarget ? 'Completed' : `${goal?.goalProgressCurrentValue}% Completed`}
                            </Typography>
                          </Box>

                          <Box className={classes.goalCardStatusContainer}>
                            <Typography className={classes.goalStatus} style={{ color: statusColors[goal.status] }}>
                              {goal?.status}
                            </Typography>
                          </Box>
                        </Box>
                      ))
                    ) : (
                      <Box
                        sx={{
                          padding: '20px',
                          textAlign: 'center',
                          color: '#666',
                        }}
                      >
                        <Typography>No milestone goals available</Typography>
                      </Box>
                    )}
                  </Box>
                </Box>
              </Grid>

              {/* Right Panel */}
              <Grid item xs={8.5}>
                <Box className={classes.rightPanel}>
                  <Box className={classes.MileStoneBox}>
                    <Box className={classes.rightPanelHeader}>
                      <Typography className={classes.rightPanelTitle}>Goal#{(isGoalData ? [data] : (milestoneDataToUse?.mileStoneGoals || [])).findIndex((goal: any) => goal.id === activeGoal.id) + 1}</Typography>

                      <Box sx={{ display: 'flex', gap: 1, alignItems: 'center' }}>
                      <Button 
                        className={classes.optionsButton}
                        onClick={handleGoalOptionsClick}
                        aria-controls={goalOptionsAnchorEl ? 'goal-options-menu' : undefined}
                        aria-haspopup="true"
                        aria-expanded={goalOptionsAnchorEl ? 'true' : undefined}
                      >
                        {' '}
                        Goal Options <ExpandMoreIcon />{' '}
                      </Button>
                      <Menu
                        id="goal-options-menu"
                        anchorEl={goalOptionsAnchorEl}
                        open={Boolean(goalOptionsAnchorEl)}
                        onClose={handleGoalOptionsClose}
                        anchorOrigin={{
                          vertical: 'bottom',
                          horizontal: 'right',
                        }}
                        transformOrigin={{
                          vertical: 'top',
                          horizontal: 'right',
                        }}
                      >
                        <MenuItem onClick={handleEditGoal}>Edit Goal</MenuItem>
                        <MenuItem 
                          onClick={handleMarkGoalComplete}
                          disabled={activeGoal?.goalProgressCurrentValue === activeGoal?.goalProgressTarget}
                        >
                          Mark Goal as Complete
                        </MenuItem>
                      </Menu>
                    </Box>
                    </Box>

                    <Box>
                      <Typography className={classes.rightPanelTitle2}>Goal#{(isGoalData ? [data] : (milestoneDataToUse?.mileStoneGoals || [])).findIndex((goal: any) => goal.id === activeGoal.id) + 1}</Typography>
                    </Box>

                    <Box className={classes.goalInformation}>
                      <Typography className={classes.goalDetailTitle}>{activeGoal.goalName}</Typography>
                      <Typography className={classes.goalDescription}>{activeGoal.description}</Typography>
                    </Box>

                    <Box className={classes.progressSection}>
                      <Box className={classes.progressInfo}>
                        <Typography className={classes.progressText}>
                          PROGRESS:{' '}
                          <Box component={'span'} sx={{ fontSize: { xs: '10.5px', ultraHD: '12px' }, color: '#333333' }}>
                            {activeGoal.goalProgressCurrentValue}%
                          </Box>
                        </Typography>
                        <Typography className={classes.progressText}>
                          GOAL DURATION:{' '}
                          <Box component={'span'} sx={{ fontSize: { xs: '10.5px', ultraHD: '12px' }, color: '#333333' }}>
                            {activeGoal.goalDuration || 'Not specified'}
                          </Box>
                        </Typography>
                        <Typography className={classes.progressText}>
                          LINKED TO:{' '}
                          <Box component={'span'} sx={{ fontSize: { xs: '10.5px', ultraHD: '12px' }, color: '#333333' }}>
                            {mentorName}
                          </Box>
                        </Typography>
                      </Box>
                    </Box>

                    <Box className={classes.goalInformation}>
                      <Typography className={classes.callsTitle}>Call Linked to the Goal</Typography>
                    </Box>

                    <Box className={classes.callsContainer}>
                      {goalTask?.map((call: any, index: number) => (
                        <Box key={call.id} className={classes.callCard}>
                          <Box className={classes.callHeader}>
                            <Typography className={classes.callId}>
                              CALL NO <Box component={"span"} sx={{ fontWeight: 600, }}>#{index + 1}</Box>
                            </Typography>
                            {/* #{index+1}</Typography> */}
                          </Box>

                          <Box sx={{ display: 'flex', flexDirection: 'column' }}>
                            <Typography className={classes.callStatus} style={{ color: statusColors[call.status] }}>
                              {call.status}
                            </Typography>
                            <Typography className={classes.callInfo}>CALL INFO: {call?.activityDate}</Typography>

                            {call.recording && <Typography className={classes.recordingLink}>Call recording link: {call.recording}</Typography>}
                          </Box>

                          <Button className={classes.optionsButton}>
                            Call Options <ExpandMoreIcon />
                          </Button>
                        </Box>
                      ))}
                    </Box>
                  </Box>
                </Box>
              </Grid>
            </Grid>
          </Box>
        </Box>
          )}
        </>
      )}
    </>
  );
};

export default GoalsAndMilestonesData;
